// https://conf.willhillatlas.com/display/NTV/Apps+User+Agent
export const isUserAgent = (userAgent) => {
  if (
    typeof window === 'undefined' ||
    typeof window.navigator === 'undefined' ||
    typeof window.navigator.userAgent !== 'string'
  ) {
    return null;
  }

  return window.navigator.userAgent.includes(userAgent);
};
